import { getProfileRequest } from "api/auth";
import Loader from "components/shared/loader";
import PopoverProvider from "providers/PopoverProvider";
import PopupProvider from "providers/PopupProvider";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { setSkinConfig } from "store/componentsSlice";
import { useAppDispatch } from "store/hooks";
import { getSkinConfigByUnivers } from "styles/skin";
import { getAppUrl } from "utils/defines";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
import { useAuth } from "utils/hooks/useAuth";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import CookieBot from "react-cookiebot";

const RootRoute: React.FC = () => {
  const { isAuth, setIsAuth, setProfile } = useAuth();
  const { setLanguage, language } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const loginProcess = location.pathname.startsWith("/wso/callback");

  const { network, isLoading, isThermor, isPacific } = useSalesNetwork();

  const languages = network?.langs;

  const dispatch = useAppDispatch();

  useEffect(() => {
    //todo review after changig routes
    const onPopState = (e: PopStateEvent) => {
      if ((window as any).IsInFormPage && (window as any).wasInSolutionsPage) {
        const state = e.state;
        const href = window.location.pathname + window.location.search;
        const cb = () => {
          window.removeEventListener("popstate", cb);
          setTimeout(() => navigate(href, { state }), 0);
        };
        window.addEventListener("popstate", cb);
        navigate(-1);
      }
      (window as any).wasInSolutionsPage = false;
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  useEffect(() => {
    const token = getLocalStorageAccessToken();

    if (token) {
      setIsAuth(true);
      return;
    }

    if (
      !network ||
      isLoading ||
      location.pathname.endsWith("/template") ||
      loginProcess
    ) {
      return;
    }

    if (
      location.pathname != getAppUrl("/") &&
      !isAuth
    ) {
      navigate(getAppUrl("/"));
    }
  }, [
    isAuth,
    isLoading,
    location.pathname,
    loginProcess,
    navigate,
    network,
    setIsAuth,
  ]);

  useEffect(() => {
    if (isAuth) {
      getProfileRequest().then((res) => {
        setProfile(res.data);
        setIsAuth(true);
      });
    }
  }, [isAuth, setProfile]);

  useEffect(() => {
    // if (languages && !language) {
    //   const storedLang = localStorage.getItem("language");
    //   if (storedLang && languages.find((l) => l.code === storedLang)) {
    //     setLanguage(storedLang);
    //   } else {
    //     setLanguage(
    //       languages.find((l) => l.isDefault)?.code || languages[0].code
    //     );
    //   }
    // }
  }, [language, languages, setLanguage]);

  useEffect(() => {
    if (network) {
      const brand: string = network?._parameters.brand;

      if (isThermor) {
        document.title = "SIMUL'HOME"
        const link = document.querySelector("link[rel~='icon']")
        link?.setAttribute('href', window.location.origin + '/favicon-thermor.png')
        const linkApple = document.querySelector("link[rel~='apple-touch-icon']")
        linkApple?.setAttribute('href', window.location.origin + '/favicon192-thermor.png')
      } else if (isPacific) {
        document.title = "PROJECT PAC AIR EAU"
        const link = document.querySelector("link[rel~='icon']")
        link?.setAttribute('href', window.location.origin + '/favicon-pacific.png')
        const linkApple = document.querySelector("link[rel~='apple-touch-icon']")
        linkApple?.setAttribute('href', window.location.origin + '/favicon192-pacific.png')
      }

      dispatch(setSkinConfig(getSkinConfigByUnivers(brand || "")));
    }
  }, [dispatch, network]);

  return network ? (
    <>
      {network && network._parameters.cookiebot && (
        <CookieBot domainGroupId={network._parameters.cookiebot} />
      )}
      <PopoverProvider>
        <PopupProvider>
          <Outlet />
        </PopupProvider>
      </PopoverProvider>
    </>
  ) : (
    <>
      <Loader />
      <Outlet />
    </>
  );
};

export default RootRoute;
